import Service from "../service";

/**
 * Company subscription API wrapper. Envelope is { status: 200 | other, data, message };
 * callers check `status === 200` (same convention as workWeekApi.js).
 */
const call = async (methodName, api_url, body) => {
  const response = await Service.makeAPICall({ methodName, api_url, body });
  return response?.data || { status: 403, message: "No response from server" };
};

const subscriptionApi = {
  /** -> data: { planName, planStartDate, planEndDate, subscriptionStatus, daysLeft, totalUsers, activeUsers, history[] } */
  getDetails: async () => {
    const response = await Service.makeAPICall({
      methodName: Service.getMethod,
      api_url: "/companySubscription/details",
    });
    return response?.data || { status: 403, message: "No response from server" };
  },

  /** -> data: [{ _id, trainingGiven, description, trainedOn, employees: [{ _id, full_name }] }] */
  getTraining: async () => call(Service.getMethod, "/companySubscription/training"),

  /** { trainingGiven, employees: [id], description } */
  addTraining: async (payload) => call(Service.postMethod, "/companySubscription/training", payload),

  editTraining: async (id, payload) => call(Service.putMethod, `/companySubscription/training/${id}`, payload),

  deleteTraining: async (id) => call(Service.deleteMethod, `/companySubscription/training/${id}`),
};

export default subscriptionApi;
